<template>
  <v-tab v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </v-tab>
</template>
<script>
export default {
  inheritAttrs: false
};
</script>